import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GroupService } from 'src/app/services/group.service';
import { GroupPlayer } from 'src/app/objects/group-player';
import { catchError, finalize } from 'rxjs/operators';

@Component({
  selector: 's18-adjust-player-index-dialog',
  templateUrl: './adjust-player-index-dialog.component.html',
  styleUrls: ['./adjust-player-index-dialog.component.scss']
})
export class AdjustPlayerIndexDialogComponent implements OnInit {
  player: GroupPlayer;
  adjustment: number;
  adjusting: boolean = false;

  constructor(
    private groupService: GroupService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<AdjustPlayerIndexDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data);
    this.player = data.player;
  }

  ngOnInit() {
  }

  onCancel() {
    this.dialog.closeAll();
  }

  onOk() {
    this.adjusting = true;
    this.groupService.processPlayerIndexAdjustment(this.player.group_id, this.player.player_id, this.adjustment.toString())
      .pipe(catchError((err) => {
        return JSON.stringify(err);
      }), finalize(() => {
        this.adjusting = false;
      }))
      .subscribe((resp) => {
        var response = JSON.parse(resp.d).response;
        if (response === "OK") {
          this.dialogRef.close(response);
        } else {
          console.log(response);
        }
      });
  }


}
